import { apyToAprPercent } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'

const MAPLE_URL = 'https://api.maple.finance/v2/graphql'

const SYRUP_USDT_ID = '0x356b8d89c1e1239cbbb9de4815c39a1474d5ba7d'
const SYRUP_USDC_ID = '0x80ac24aa929eaf5013f6436cda2a7ba190f5cc0b'
const SYRUP_USDG_ID = '0x87b65c4aaffa76881f9e96f3e7ed945ddfc3cd7a'

interface MaplePool {
  id: string
  weeklyApy: string
}

export const mapleFetcher: YieldFetcher = {
  label: 'MAPLE',
  fetch: async () => {
    const res = await fetch(MAPLE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        operationName: 'getPoolsApyCached',
        variables: {
          excludePools: [
            '0xb1206b74f612f478c12a647d12e7e822af5d8244',
            '0x7afa9cea7a060a84401c7209c02af989b391cc87',
          ],
        },
        extensions: {
          persistedQuery: {
            version: 1,
            sha256Hash:
              '9a6fa44cdfea98eb68c548e0d06d0a6b018d3c1d8e0a0e2a8bc174cd8fdb9a7b',
          },
        },
      }),
    }).then((r) => r.json())

    const pools: MaplePool[] = res.data.poolV2S

    const usdtPool = pools.find((p) => p.id === SYRUP_USDT_ID)
    const usdcPool = pools.find((p) => p.id === SYRUP_USDC_ID)
    const usdgPool = pools.find((p) => p.id === SYRUP_USDG_ID)

    const parseApy = (raw: string) => Number(raw) / 1e28

    return {
      SYRUPUSDT: apyToAprPercent(parseApy(usdtPool!.weeklyApy)),
      SYRUPUSDC: apyToAprPercent(parseApy(usdcPool!.weeklyApy)),
      SYRUPUSDG: apyToAprPercent(parseApy(usdgPool!.weeklyApy)),
    }
  },
}
